import { TeamPermission, TeamPermissionCategory } from 'src/constants/team/enums'
import { teamPermissionTextMap, teamPermissionCategoryTextMap } from 'src/constants/team/constants'
import { TeamPermissions } from 'src/interfaces/team'
import _ from 'lodash'

export const getPermissionTitle = (permission: string) => {
  return (
    teamPermissionTextMap[permission as keyof typeof teamPermissionTextMap] ||
    _.startCase(permission)
  )
}

export const getCategoryTitle = (category: string) => {
  return (
    teamPermissionCategoryTextMap[category as keyof typeof teamPermissionCategoryTextMap] ||
    _.startCase(category)
  )
}

export const mapRolePermissionsWithLabels = (
  rolePermissions: TeamPermissions,
): Partial<Record<TeamPermissionCategory, string[]>> => {
  return Object.entries(rolePermissions).reduce((acc, [categoryKey, permissions]) => {
    const category = categoryKey as TeamPermissionCategory

    if (Array.isArray(permissions) && permissions.length > 0) {
      acc[category] = permissions.map((permission) =>
        getPermissionTitle(permission as TeamPermission),
      )
    }

    return acc
  }, {} as Partial<Record<TeamPermissionCategory, string[]>>)
}

export const groupPermissionsByCategory = (
  allPermissions: TeamPermissions,
  permissions: TeamPermission[] | undefined,
): Partial<Record<string, string[]>> => {
  const result: Record<string, string[]> = {}

  if (!permissions) {
    return result
  }

  permissions.forEach((permission) => {
    Object.entries(allPermissions).forEach(([categoryKey, allowedPermissions]) => {
      const category = categoryKey as TeamPermissionCategory

      if (allowedPermissions && allowedPermissions.includes(permission)) {
        const displayName = getCategoryTitle(category)

        if (!result[displayName]) {
          result[displayName] = []
        }

        result[displayName].push(getPermissionTitle(permission))
      }
    })
  })

  return result
}
